import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { FileText, Plus, Construction } from "lucide-react";

const ClasificadorLicores = () => {
  return (
    <div className="space-y-6" data-testid="clasificador-licores-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 bg-rose-100 rounded-lg flex items-center justify-center">
            <FileText className="w-6 h-6 text-rose-700" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Clasificador de Licores</h1>
            <p className="text-sm text-slate-500">
              Clasificación fiscal y tarifas aplicables a la venta de licores
            </p>
          </div>
        </div>
        <Button disabled className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="btn-new-clasif-licor">
          <Plus className="w-4 h-4 mr-2" /> Nueva Clasificación
        </Button>
      </div>

      <Card className="border-dashed border-2 border-slate-300">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-slate-700">
            <Construction className="w-5 h-5 text-rose-600" /> Submódulo en construcción
          </CardTitle>
          <CardDescription>
            Los campos del clasificador serán definidos próximamente. Este submódulo incluirá:
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="text-sm text-slate-600 space-y-2 list-disc ml-5">
            <li>Código de la clasificación</li>
            <li>Descripción de la categoría fiscal</li>
            <li>Actividad (Expendio, Distribución, Venta al por mayor/menor)</li>
            <li>Alícuota / porcentaje aplicable</li>
            <li>Base imponible y unidad de cálculo</li>
            <li>Unidad Tributaria (UT) aplicable</li>
            <li>Periodicidad (Mensual / Trimestral / Anual)</li>
            <li>Vigencia (fecha inicio - fecha fin)</li>
            <li>Estatus (Activa / Derogada)</li>
          </ul>
          <p className="mt-4 text-xs text-slate-400 italic">
            Comparta los campos específicos con el equipo de desarrollo para habilitar este submódulo.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClasificadorLicores;
